import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStylesResult = makeStyles((theme) => {
    const cssObjext = {
        body: {
            fontSize: 14,
            color: "white",
            background: props => theme.lpb.resultBackgroundColors[props.resValue],
            padding:0
        }
    }
    return cssObjext;
});

const CustomCellFormatter = (props) => {
    const resultClasses = useStylesResult({ ...props, resValue: props.value });
    if (props.column.key === "result") {
        return (
            <div className={resultClasses.body}>{props.value}</div>
        );
    }
}

export default CustomCellFormatter;